import { WidgetCard } from './WidgetCard.tsx';
import { Box, Typography } from '@mui/material';

type ContentProps = {
  widgets:       WidgetInstance[];
  osmName:       string;
  dateFromValue: Dayjs | null;
  dateToValue:   Dayjs | null;
  editMode:      boolean;
  onEdit:        (w: WidgetInstance) => void;
  onDelete:      (id: number) => void;
  onMove:        (index: number, direction: 'up' | 'down') => void;
};

export function DashboardContent({
  widgets, osmName, dateFromValue, dateToValue,
  editMode, onEdit, onDelete, onMove,
}: ContentProps) {
  if (!widgets.length) {
    return (
      <Typography color="text.secondary" sx={{ p: 2 }}>
        {editMode ? 'No widgets yet — click + to add some.' : 'No dashboard configured.'}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2, p: 2 }}>
      {widgets.map((widget, index) => (
        <WidgetCard
          key={`${widget.id}-${dateFromValue?.toISOString()}-${dateToValue?.toISOString()}`}
          widget={widget}
          osmName={osmName}
          dateFromValue={dateFromValue}
          dateToValue={dateToValue}
          editMode={editMode}
          index={index}
          total={widgets.length}
          onEdit={onEdit}
          onDelete={onDelete}
          onMove={onMove}
        />
      ))}
    </Box>
  );
}
